import { Component } from '@angular/core';
import { User } from "src/app/models/user";
import { AppState } from "src/app/services/app.service";
import { SubdomainConfigService, ContactInfo } from 'src/app/services/subdomainConfig.service';
import { TranslateHelperService } from "src/app/services/TranslateService";

@Component({
    selector: 'contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent{
    public user: User;
    public email: string;
    public phone: string;
    public claimsReportingUrl: string;
    public supportEmail: string;

    public constructor(
        public _translateService: TranslateHelperService,
        private appState: AppState,
        private subdomainConfigService: SubdomainConfigService
    ) {
        this.user = this.appState.user.getValue();

        const contactInfo: ContactInfo = this.subdomainConfigService.getContactInfo();
        this.email = contactInfo.email;
        this.phone = contactInfo.phone;
        this.claimsReportingUrl = contactInfo.claimsReportingUrl;
        this.supportEmail = contactInfo.supportEmail;
    }
}
